module.exports = __webpack_public_path__ + "TiemposFine-Regular.svg?6767ab0f94a5ffadd9930bdec5210568";